// ⇘⇘⇘⇘⇘⇘⇘   ⇓ ⇓ ⇓ ⇓ ⇓  ⇙⇙⇙⇙⇙⇙⇙⇙
// ⇒⇒⇒⇒⇒⇒ *R*E*A*C*T* ⇐⇐⇐⇐⇐⇐
// ⇗⇗⇗⇗⇗⇗⇗   ⇑ ⇑ ⇑ ⇑ ⇑  ⇖⇖⇖⇖⇖⇖⇖⇖

import React, { useEffect } from 'react';

// Basically bootstrap
import { Row, Col, Card } from 'react-bootstrap';

// Roba di redux
import { useSelector, useDispatch } from 'react-redux';

// Componente per navigare tra le paGGine
import { Link } from 'react-router-dom';

// Funzioni scritte da me
import { selezionaContratto } from 'features/80/contratti/contrattiSlice';
import { getContrattiSupp } from './funzioni';

// Il mio input bellissimo per editare la cella
import Modifica from './components/modifica';
import UploadFile from './components/uploadFile';

// Type Mapping dal tipo restituito dall'api al tipo nativo dell'input
const typeMappings = {
  DATA: 'date',
  STRINGA: 'text',
  INTERO: 'number',
  DECIMALE: 'number',
};

// COMPONENTE PRINCIPALE A.K.A. LA PAggINA
const ContrattoSupp = ({ match }) => {
  // Prendo le variabili di stato dallo store redux (sarebbe un useState globale)
  const { isDettagliLoading, idContratto, contrattoCorrente, contrattiSupp } = useSelector((state) => state.contratti80);

  // Questo robo qui serve per chiamare le funzioni che modificano lo stato
  const dispatch = useDispatch();

  // Controllo di essere in possesso dei dati del contratto perché
  // Senza id del contratto (idContratto) non posso fare richiesta dei dettagli
  // mentre il parametro (contrattoCorrente) è il codice del contratto.
  // So che andrebbero messi insieme solo che invece di fare cose utili sto scrivendo
  // Questo commento.
  if (!idContratto || !contrattoCorrente) {
    // Se non sono in possesso dei parametri di cui sopra, allora controllo che mi vengano passati dall'URL.
    // **MOTIVAZIONE**
    // Se apro i dettagli del contratto dalla pagina dei contratti, il contratto selezionato si trova nello stato.
    // In questo caso, sono in possesso dei parametri senza che essi si trovino nell URL.
    // Se ricarico la pagina, però, perdo lo stato corrente e di conseguenza non ho piu l'id del contratto
    // per fare richiesta al backend. Pertanto passo questi parametri anche nell'URL in modo che, se la pagina viene ricaricata,
    // posso accedere ai parametri anche se non sono caricati nello stato.
    if (match.params.id && match.params.nome && !Number.isNaN(Number(match.params.id))) {
      // Carica i parametri nello stato nel caso descritto sopra
      dispatch(selezionaContratto({ idContratto: match.params.id, codiceContratto: decodeURIComponent(match.params.nome) }));
    } else {
      // *Eccezione*
      // Se i parametri del contratto non sono presenti e/o validi sia nello stato che nell'URL,
      // allora mostro un messaggio di errore e do la possibilità all'utente di tornare indietro
      return (
        <>
          <h1 className="text-danger">ERRORE FATALE NEL RICHIEDERE I DETTAGLI DEL CONTRATTO. TORNA INDIETRO PER RIPROVARE</h1>
          <Link to="/80/contratti/">Return back</Link>
        </>
      );
    }
  }

  // Richiedo i dati supplementari del contratto al caricamento della pagina
  useEffect(getContrattiSupp, []);

  // Layout da mostrare se i dati supplementari vengono caricati con successo
  const modificaDettagli = (
    <Row className="g-3">
      {
        /* 
        Controllo che i dettagli supplementari sono preseni, e se lo sono 
        mostro la tabella che li contiene
      */
        contrattiSupp &&
          contrattiSupp.map((item1, idx) => {
            return (
              <Card key={idx} className="border">
                <Card.Header className="p-4">
                  <Card.Title className="m-0">
                    <h5 className="fs-4 text-primary m-0">{item1.nome}</h5>
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row className="g-3">
                    {item1.campi.map((item, index) => {
                      if (item.Tipo.trim() === 'ALLEGATO') {
                        return (
                          <Col sm="12" md="6" lg="4" key={idx}>
                            <UploadFile descrizione={item.Descrizione} modificabile={!!item.Modifica} idDato={item.Dato} />
                          </Col>
                        );
                      }
                      return (
                        <Col sm="12" md="6" lg="4" key={idx}>
                          <Modifica
                            descrizione={item.Descrizione}
                            tipo={typeMappings[item.Tipo.trim()]}
                            valore={item.Valore}
                            modificabile={item.Modifica}
                            idDato={item.Dato}
                            formatoData={item.Tipo.trim() === 'DATA'}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                </Card.Body>
              </Card>
            );
          })
      }
    </Row>
  );

  // Componente returnato di default
  return (
    <>
      <Row>
        <Col>
          {/* START SEZIONE TITOLO */}
          <section className="scroll-section mb-5" id="titolo">
            <h1>Details {contrattoCorrente /* Il codice del contratto (es. 169/21) */}</h1>
            <Link to="/80/contratti/">{'<'} Return back</Link>
          </section>
          {/* END SEZIONE TITOLO */}

          <section className="scroll-section" id="dettagli-contratto">
            {
              /* Controllo se la pagina è in stato di caricamento */
              isDettagliLoading
                ? /* Se sta caricando, mostro un messaggio di caricamento 
                TODO: Rimpiazzare il messaggio con uno spinner */
                  'Caricamento in corso'
                : /* Se non sta caricando, mostro il layout principale */
                  modificaDettagli
            }
          </section>
        </Col>
      </Row>
    </>
  );
};

export default ContrattoSupp;
